// extracted by mini-css-extract-plugin
module.exports = {"maindiv":"ScreenLayout_maindiv__3tIbO","content_div":"ScreenLayout_content_div__A4i34"};